// 사이트 지원 언어: 한국어(원문) + 영어
// code: languageStore 코드, file: src/i18n/dict/{file}.json, html: <html lang>
// ponytail: 언어를 늘리려면 여기에 항목과 dict/{file}.json을 추가 (참고 소스에 14개 언어 사전 있음)
export const LANGUAGES = [
  { code: "KR", label: "KOR", html: "ko" },
  { code: "EN", label: "ENG", html: "en", file: "en" },
];
export const findLanguage = (code) => LANGUAGES.find((l) => l.code === code) || LANGUAGES[0];
